import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import moment from "moment";
import * as Sentry from "@sentry/browser";

import api from "../../libs/api";

import { Loading } from "@magic-engineering/components";
import ViewMore from "../ViewMore/ViewMore";

import "./Billing.scss";
import downloadIcon from "../../assets/images/download-cloud.svg";

function Billing() {
  const [bills, setBills] = useState(null);
  const [viewAll, setViewAll] = useState(false);

  const MAX_DISPLAYED = 5;
  const length = viewAll ? bills.length : MAX_DISPLAYED;

  useEffect(() => {
    const fetchBills = async () => {
      try {
        const { data } = await api.get("/clients/bills");
        setBills(data.bills);
        // TODO: clear Sentry
        Sentry.withScope((scope) => {
          scope.setLevel("info");
          Sentry.captureMessage(
            `Billing page loaded: ${
              data.bills && data.bills.length ? data.bills.length : "No bills"
            } bills`
          );
        });
      } catch (e) {
        console.error("Failed to fetch bills", e);
        setBills([]);
        Sentry.withScope((scope) => {
          scope.setLevel("warning");
          Sentry.captureMessage(e);
        });
      }
    };
    if (!bills) fetchBills();
  }, [bills]);

  if (!bills) {
    return <Loading size="Medium" />;
  }

  if (bills && bills.length === 0) {
    return (
      <div id="billing" className="row no-gutters" data-testid="BillingEmpty">
        <div className="col-12">
          <h2 className="mb-3">Billing History</h2>
        </div>
        <div className="col-12">
          <span className="color-default">No bills to display at the moment.</span>
        </div>
      </div>
    );
  }

  const BillingView = () => (
    <div id="billing" className="row no-gutters" data-testid="Billing">
      <div className="col-12">
        <h2 className="mb-3">Billing History</h2>
      </div>
      <div className="col-12 col-xl-9">
        <table className="billing-table w-100" data-testid="BillingTable">
          <thead>
            <tr>
              <th>
                <h3 className="header">Week</h3>
              </th>
              <th>
                <h3 className="header text-center">Amount</h3>
              </th>
              <th>
                <h3 className="header text-center">Card Used</h3>
              </th>
              <th>
                <h3 className="header float-right">Download</h3>
              </th>
            </tr>
          </thead>
          <tbody>
            {bills.slice(0, length).map((bill) => (
              <tr key={bill._id}>
                <td>{moment(bill.chargedAt).format("MMM DD, YYYY")}</td>
                <td>${bill.amount}</td>
                <td>
                  {bill.card && Object.keys(bill.card).length > 0
                    ? `${bill.card.brand} ${bill.card.last4}`
                    : "---"}
                </td>
                <td>
                  <Link to={`/bill/${bill._id}?chargedAt=${bill.chargedAt}`}>
                    <img src={downloadIcon} alt="download" className="mr-2" /> PDF / HTML
                  </Link>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        <div className="mb-3">
          <ViewMore
            values={bills}
            maxDisplayed={MAX_DISPLAYED}
            viewAll={viewAll}
            setViewAll={setViewAll}
          />
        </div>
      </div>
    </div>
  );

  return <BillingView />;
}

export default Billing;
